<script>
	export let text;
	export let colorScale;
	export let tickValues;
	export let tickLabels;
	export let textWidth;

	$: tickValues = tickValues || colorScale.domain();
	$: tickLabels = tickLabels || colorScale.domain();

	$: maxTickValue = tickValues[tickValues.length - 1];
	$: minTickValue = tickValues[0];

	const calcRelativePosition = (value) => {
		return ((value - minTickValue) / (maxTickValue - minTickValue)) * 100;
	};

	$: gradient =
		"linear-gradient(to right, " +
		colorScale
			.range()
			.map((color, index) => {
				const domainValue = colorScale.domain()[index];
				const percent = calcRelativePosition(domainValue); // Assuming 0.045 is your max value in domain
				return `${color} ${percent}%`;
			})
			.join(", ") +
		")";
</script>

<div class="legend">
	<div class="legend__text" style:width={textWidth ? textWidth + "px" : ""}>
		{@html text}
	</div>
	<div class="legend__scale">
		<div class="scale" style:background={gradient} />
		<div class="domain">
			{#each tickValues as value, i}
				<div class="tick" style:left={calcRelativePosition(value) + "%"}>
					<div class="tick-line" />
					<div class="tick-label">
						{tickLabels[i]}
					</div>
				</div>
			{/each}
		</div>
	</div>
</div>

<style lang="scss">
	.legend {
		display: flex;
		margin: 10px 0;
		// align-items: center;
		justify-content: flex-start;
		margin-bottom: 20px;

		@media (max-width: $breakpoint-tablet-s) {
			justify-content: space-between;
			height: 32px;

			&__text {
				margin-right: 15px;
			}

			&__scale {
				margin-right: 12px;
			}
		}

		&__text {
			font-size: 13px;
			color: #2a2a2a;
			width: 230px;
		}

		&__scale {
			.domain {
				position: relative;

				.tick {
					position: absolute;
					transform: translate(-50%, 0);
					display: flex;
					flex-direction: column;
					align-items: center;

					.tick-line {
						height: 7px;
						width: 1px;
						transform: translateX(-50%);
						background-color: #c2c1c1;
					}
				}
			}
		}
	}

	.scale {
		height: 7px;
		width: 120px;
		transition: background-color 0.3s ease-in-out;
	}
</style>
